import { ContainerModule } from 'inversify';
import DITypes from './types';
import type { IAdapterFactory, IDispatcher, IDispatcherFactory } from '@dm-portal/json-rpc-dispatcher/DI/interfaces';
import { DmPortalDispatcherFactory } from '../DmPortalDispatcherFactory';
import AdapterFactory from '@framework/di/Providers/Rpc/AdapterFactory';

export const DmPortalDmPortalDispatcherModule = new ContainerModule(({ bind }) => {
  bind<IAdapterFactory>(DITypes.AdapterFactory).to(AdapterFactory).inSingletonScope();

  bind<IDispatcherFactory>(DITypes.DispatcherFactory).to(DmPortalDispatcherFactory).inSingletonScope();

  bind<IDispatcher>(DITypes.JsonRpcDispatcher).toDynamicValue(({ get }) => (
    get<IDispatcherFactory>(DITypes.DispatcherFactory).create()
  )).inSingletonScope();
});
